import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

export function useSaveGeneralEvolution() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((evolution) => {
    setSaving(true);
    return quarkusApi
      .post('/paciente/evolucao', evolution, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
